function getOverviewSpacer() {
    return document.querySelector("#overview-spacer")
}

// Declare guard variables in the global scope to avoid redefining on every load
if (!window.overviewInitialized) {
    // Tracks the interval
    window.intervalId = null;
    // Flag to prevent duplicate listeners
    window.visibilityListenerAttached = false;
    // Guard to track whether overview.js has been initialized
    window.overviewInitialized = true;
}

document.addEventListener('turbolinks:load', function() {
    let overviewSpacer = getOverviewSpacer();
    if (!overviewSpacer) { return }
    // free up the $ variable for use in jquery when turbolinks reloads javascript
    // if not loaded, enable the modal plugin
    if (typeof $().modal !== "function") { jQuery.noConflict() }
    // set up path for re-rendering overview contents
    const url = window.location.pathname;
    const matches = url.match(/\d+/g);
    const courseID = matches[0];
    const assignmentID = matches[1];
    const newPath = `/courses/${courseID}/assignments/${assignmentID}/overview`;

    // Submits an AJAX request to visit the current page again, updating the overview
    function updateOverviewPage() {
        let editMode = document.querySelector('.assignment-launch-left').dataset.editMode === "true";
        let sync_icon = document.getElementById('last-updated-sync-icon');
        $.ajax({
            url: newPath,
            type: 'GET',
            dataType: 'html',
            success: function () {
                if (editMode === false) {
                    // Visit page with Turbolinks to avoid "flashing" header bar and page content
                    Turbolinks.ProgressBar.prototype.refresh = function() {}
                    Turbolinks.ProgressBar.defaultCSS = ""
                    Turbolinks.visit(location);
                    // Applies a spin animation to the sync icon
                    sync_icon.classList.add('sync-icon-spin-animation');
                    setTimeout(() => {
                        sync_icon.classList.remove('sync-icon-spin-animation');
                    }, 1500);
                }
            }
        });
    }

    function visibilityHandler() {
        if (document.visibilityState === 'visible') {
            if (window.intervalId !== null) {
                // Clear any existing interval (extra safety)
                clearInterval(window.intervalId);
            }
            window.intervalId = setInterval(() => {
                updateOverviewPage();
            }, 1500);
        }
        else {
            // Clear the interval when the tab is hidden
            if (window.intervalId !== null) {
                clearInterval(window.intervalId);
                window.intervalId = null;
            }
        }
    }

    // Attach the visibilitychange listener only once
    if (!window.visibilityListenerAttached) {
        window.addEventListener('visibilitychange', visibilityHandler);
        window.visibilityListenerAttached = true;
    }

    // Changes the sync icon to appear clickable when hovered
    document.querySelector('#last-updated-sync-icon').style.cursor = 'pointer';


    // Prevents default behavior for external course links, to prevent double tab opening
    document.getElementById('logo-manage-course-link').addEventListener('click', function (event) {
        event.preventDefault();
    });
    document.getElementById('bar-manage-course-link').addEventListener('click', function (event) {
        event.preventDefault();
    });

    // Applies a spin animation to the sync icon when clicked
    document.getElementById('last-updated-sync-icon').addEventListener('click', function () {
        this.classList.add('sync-icon-spin-animation');
        setTimeout(() => {
            this.classList.remove('sync-icon-spin-animation');
        }, 1500);
    });

    // Assesses a data attribute in order to hide the new tab version of the edit button for immersive assignments
    let isImmersiveAssignment = document.querySelector('.assignment-launch-left')?.dataset.isImmersiveAssignment === "true";

    // iframe detection used for conditional rendering of multiple elements on overview page
    if (window.location !== window.parent.location) {
        // in iframe
        document.querySelector("#overview-spacer")?.style.setProperty('display', 'none')
        document.querySelector("#overview-assignment-launch-button-self")?.style.setProperty('display', 'none', 'important')
        document.querySelector("#bar-manage-course-link").style.display = "none"
        document.querySelector("#logo-manage-course-link").style.display = "flex"
        document.querySelector("#edit-mode-action-button-container")?.style.setProperty('display', 'none', 'important')
        document.querySelectorAll("[id*='activity-title-overview-iframe']").forEach(element => {
            element.style.setProperty('display', 'none', 'important');
        });
        document.querySelectorAll("[id*='activity-title-overview-new-tab']").forEach(element => {
            element.style.cursor = 'pointer';
        });
    } else {
        // not in iframe
        document.querySelector("#overview-assignment-launch-button-new")?.style.setProperty('display', 'none', 'important')
        document.querySelector("#bar-manage-course-link").style.display = "flex"
        document.querySelector("#logo-manage-course-link").style.display = "none"
        document.querySelectorAll("[id*='activity-title-overview-new-tab']").forEach(element => {
            element.style.setProperty('display', 'none', 'important');
        });
        if (isImmersiveAssignment === true) {
            document.querySelector("#edit-mode-action-button-new-tab-container")?.style.setProperty('display', 'none', 'important')
        }
    }
});

// Turbolinks lifecycle: Clean up before navigating away to avoid duplication
document.addEventListener('turbolinks:before-render', () => {
    let overviewSpacer = getOverviewSpacer();
    if (!overviewSpacer) { return }
    // Clear active intervals
    if (window.intervalId !== null) {
        clearInterval(window.intervalId);
        window.intervalId = null;
    }
});